// @flow
import * as React from 'react'
import {translate} from 'react-i18next'
import {
  Header,
  LangSelect,
  MainMenu,
  NavLink
} from 'tutellus-ui'

import {
  Main,
  Footer
} from './Layout'
import {
  WIP,
  WIPLink
} from './WIPModal'
import {
  Seo
} from './components/Seo'

const localeList = {
  es: {name: 'ESP', flag: 'es'},
  en: {name: 'ENG', flag: 'gb'}
}
const LanguageSelector = translate()(({i18n}) =>
  <LangSelect locales={localeList}
    selected={i18n.language}
    onLanguage={lang => i18n.changeLanguage(lang)} />
)

const AppMenu = translate('menu')(({t}) =>
  <MainMenu languageSelector={<LanguageSelector />}>
    <NavLink exact to='/'>{t('home')}</NavLink>
    <NavLink exact to='/carreras/'>{t('careers')}</NavLink>
    <WIPLink href='https://www.tutellus.com/cursos'>{t('courses')}</WIPLink>
  </MainMenu>
)

export const Page = ({children} /*: {children: React.Node} */) =>
  <React.Fragment>
    <Seo />
    <WIP>
      <Header logo='https://lib.tutellus.com/images/tutellus.com-logo.svg'>
        <AppMenu />
      </Header>
      <Main>
        { children }
      </Main>
      <Footer />
    </WIP>
  </React.Fragment>

Page.displayName = 'Page'



// WEBPACK FOOTER //
// ./src/pages/Page.js